import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const AcademicQualification = ({ roles }) => {

    return (
        <M_Table entityName={'DriverAcademicQualification'} filtersOnTable rolePermissions={roles} />
    )
}